export default __webpack_public_path__ + "static/media/proca-icon-darkactive-512.30347931.png";